export default "__VITE_ASSET__CG$kr3xi__"